import styled from 'styled-components';

export const Icon = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  opacity: 0.75;
  color: ${({ theme }) => theme.neutral_300};

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const Figure = styled.figure`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;

  &:not(:hover) {
    ${Icon} {
      display: none;
    }
  }
`;

export const Image = styled.img`
  width: 100%;
`;
